import { AppConfig } from './app';
import { GetPublicIdpDetailsOutput } from '../hooks/useGetPublicIdpDetails';

export type IdProvider = {
  idp: string;
  url: string;
  lastUsedIdpDisplayName?: string;
  userPoolId?: string;
  clientId?: string;
  idpType?: string;
  /**
   * Social login hint to forward to AWS Builder ID when this provider
   * represents a social sign-in redirect (see `getSocialAuthFactorHint`).
   * Only set when the `identity_provider` URL param was a social IdP value
   * such as `GithubSocial`.
   */
  authFactorHint?: string;
};

export type GandalfUser = {
  vibeId: string;
  hatId: string;
  providerName: string;
  name?: string;
  eulaStatus?: string;
  jwtToken?: string;
  email?: string;
  nonce?: string;
  associate_to?: Associate_to;
  failed_associate?: FailedAssociate;
  new_user?: boolean | string;
  created_on?: number;
  email_verified?: boolean;
  user_merge_consented?: boolean;
  invitation?: Invitation;
  email_verification_required?: boolean;
  organization?: Organization;
  deactivated?: boolean;
  signin_switch_needed?: string;
  profile_completion_status?: string;
  simplified_profile_completed?: string;
  suspended?: string;
  migration_status?: MigrationStatus;
  identities?: [Identity];
  autoLinkConsent?: Consent;
  signin_switch_needed_b2i?: string;
};

export type AuthToken = {
  originalRequestURL: string;
  jwtToken: string;
  nonce: string;
};

export type PostAuthComponentParams = {
  user: GandalfUser;
  onContinue: () => void;
  onCancel: () => void;
  config: AppConfig;
  error?: Error;
  setError: (error: any) => void;
  consentAccepted: boolean | undefined;
  setConsetAccepted: (isAccepted: boolean) => void;
  idpDetails?: GetPublicIdpDetailsOutput;
};

export enum AmplifyAuthEvent {
  signIn = 'signIn',
  cognitoHostedUI = 'cognitoHostedUI',
  customOAuthState = 'customOAuthState',
  signOut = 'signOut',
  signIn_failure = 'signIn_failure',
  cognitoHostedUI_failure = 'cognitoHostedUI_failure',
  customState_failure = 'customState_failure',
}

export enum ExclusivityType {
  EXCLUSIVE = 'EXCLUSIVE',
  INCLUSIVE = 'INCLUSIVE',
}

export type Identity = {
  providerName: string;
};

export type Associate_to = {
  HatId: string[] | string;
  VibeId: string[] | string;
  Exclusivity: ExclusivityType;
  LinkedToIDP: string[] | string;
  LinkedToLastSignedIn: string[] | string;
  OrganizationIds?: string[] | string;
};

export type Invitation = {
  id: string;
  is_restricted_org: boolean;
  invitationUserID: string;
  organization_name: string;
  learner_data_consent_required: boolean;
};

export type Organization = {
  name: string;
  id: string;
  is_restricted: string;
};

export type FailedAssociationEntry = {
  IDP: string;
  LastSignedIn: number;
};

export type FailedAssociate = {
  FailedAssociations: FailedAssociationEntry[];
};

export type Consent = {
  merge_type: string;
  idp: string;
  last_signed_in: number;
};

export enum MigrationStatus {
  MIGRATED = 'MIGRATED',
  IN_PROGRESS = 'IN_PROGRESS',
  NOT_MIGRATED = 'NOT_MIGRATED',
}
